import Vue from 'vue';
import { CountUp } from 'countup.js';
import {
    throttle
} from 'lodash-es';


Vue.directive('scroll', {
    inserted: function (el, binding) {
        const handlerFunction = binding.value || handleScroll;

        let f = function (evt) {
            if (handlerFunction(evt, el)) {
                document.removeEventListener('scroll', f)
            }
        }

        // we need to wait a little to handle if the element is already on the viewport without scroll
        setTimeout(f, 800);
        document.addEventListener('scroll', throttle(f, 200));

    }
})

Vue.mixin({
    methods: {
        handleScroll,
        isVisible
    }
})

function isVisible(el) {
    const bounding = el.getBoundingClientRect()
    const bottomDistance = Number(el.dataset.scrollButtonDistance || 0);
    const isOnTheButton = bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + bottomDistance;

    return bounding.top >= 0 && isOnTheButton;
}

function handleScroll(evt, el) {
    if (isVisible(el) && el.dataset.scrollClass) {
        const classes = el.dataset.scrollClass.trim().split(" ");
        classes.forEach(className => {
            const classList = Array.from(el.classList)
            if (!classList.includes(className)) {
                el.classList.add(className)

                if (el.dataset.scrollCountTo) {
                    const countUp = new CountUp(el, el.dataset.scrollCountTo, {
                        duration: 3
                    });
                    countUp.start()
                }
            }
        });
    } else if (el.dataset.scrollClass && !el.dataset.scrollOnce) {
        const classes = el.dataset.scrollClass.split(" ");
        classes.forEach(className => {
            el.classList.remove(className)
        });
    }
}